



















































import Vue from "vue";
import Component from "vue-class-component";
import ClientListElementAbstract from "@/components/ClientAbstract/ClientListElementAbstarct";

@Component({})
export default class ClientListElement extends ClientListElementAbstract {}
